/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LicenseSummary } from './LicenseSummary';
import {
    LicenseSummaryFromJSON,
    LicenseSummaryFromJSONTyped,
    LicenseSummaryToJSON,
    LicenseSummaryToJSONTyped,
} from './LicenseSummary';
import type { PendingInvitation } from './PendingInvitation';
import {
    PendingInvitationFromJSON,
    PendingInvitationFromJSONTyped,
    PendingInvitationToJSON,
    PendingInvitationToJSONTyped,
} from './PendingInvitation';

/**
 * What needs an administrator's action.
 * @export
 * @interface AdminActions
 */
export interface AdminActions {
    /**
     * 
     * @type {LicenseSummary}
     * @memberof AdminActions
     */
    license: LicenseSummary;
    /**
     * 
     * @type {Array<PendingInvitation>}
     * @memberof AdminActions
     */
    pending_invitations?: Array<PendingInvitation>;
}

/**
 * Check if a given object implements the AdminActions interface.
 */
export function instanceOfAdminActions(value: object): value is AdminActions {
    if (!('license' in value) || value['license'] === undefined) return false;
    return true;
}

export function AdminActionsFromJSON(json: any): AdminActions {
    return AdminActionsFromJSONTyped(json, false);
}

export function AdminActionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminActions {
    if (json == null) {
        return json;
    }
    return {
        
        'license': LicenseSummaryFromJSON(json['license']),
        'pending_invitations': json['pending_invitations'] == null ? undefined : ((json['pending_invitations'] as Array<any>).map(PendingInvitationFromJSON)),
    };
}

export function AdminActionsToJSON(json: any): AdminActions {
    return AdminActionsToJSONTyped(json, false);
}

export function AdminActionsToJSONTyped(value?: AdminActions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'license': LicenseSummaryToJSON(value['license']),
        'pending_invitations': value['pending_invitations'] == null ? undefined : ((value['pending_invitations'] as Array<any>).map(PendingInvitationToJSON)),
    };
}

